/* eslint  import/no-unresolved: 0 */ // Needed for the build phase (with admin/public apps)

// These must be the first lines in src/index.js
import 'react-app-polyfill/ie9.js';
import 'react-app-polyfill/ie11.js';
import 'react-app-polyfill/stable.js';
import './index.css';

// import { Provider, ErrorBoundary } from "@rollbar/react";
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';

import { I18nextProvider } from 'react-i18next';
import { ClipLoader } from 'react-spinners';
import AdminApp from './apps/AdminApp.js';
import i18n from './i18n.js';
import * as serviceWorker from './serviceWorker.js';

// const rollbarConfig = {
//   accessToken: "2e481d1e748646b7a3f61251f7bd7442",
//   captureUncaught: true,
//   captureUnhandledRejections: true,
//   environment: 'testenv',
//   server: {
//     root: "http://example.com/",
//     branch: "main",
//   },
//   code_version: "0.13.7",
//   person: {
//     id: 117,
//     email: "chief@unsc.gov",
//     username: "john-halo",
//   },
// };

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    width: '100vw',
  },
};

class StackBoundary extends React.Component {
  componentDidCatch(err, info) {
    // info.componentStack is the React tree leading to TopBar
    console.error('Component stack:\n', info.componentStack);
  }
  render() {
    return this.props.children;
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <StackBoundary>
    <React.StrictMode>
      <I18nextProvider i18n={i18n}>
        <Suspense
          fallback={
            <div style={styles.container}>
              <ClipLoader size={60} color="#19A4BB" />
            </div>
          }
        >
          <AdminApp />
        </Suspense>
      </I18nextProvider>
    </React.StrictMode>
  </StackBoundary>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
